module.exports = __webpack_public_path__ + "static/img/tm-5.54cf9b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-5.jpg
// module id = PY2O
// module chunks = 0